import { c as _c } from "react/compiler-runtime";
export type IRatingStarsProps = {
  rating: number;
};
export const RatingStars: React.FC<IRatingStarsProps> = t0 => {
  const $ = _c(3);
  const {
    rating
  } = t0;
  let t1;
  if ($[0] !== rating) {
    const jsx = [];
    for (let i = 0; i < Math.floor(rating); i++) {
      jsx.push(<img alt="full rating star" key={`ystar-${i}`} src="/assets/svg/ratings/star-yellow.svg" />);
    }
    if (rating % 1 !== 0) {
      let t2;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <img alt="partial rating star" key="pstar" src="/assets/svg/ratings/star-yellow-half.svg" />;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      jsx.push(t2);
    }
    for (let j = 0; j < rating - Math.ceil(rating); j++) {
      jsx.push(<img alt="empty rating star" key={`star-${j}`} src="/assets/svg/ratings/star.svg" />);
    }
    t1 = <div className="flex flex-row">{jsx}</div>;
    $[0] = rating;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};